import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	releases: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	releases: {
		id: 'spa-apps-software-releases-version-detail.releases',
		defaultMessage: 'Releases',
		description: 'breadcrumb label that links to Releases home',
	},
});
export default messages;
